export const texts = {
  phoneText: '(11) 2394-9845',
  phone: '551123949845',
  cambio: {
    title: 'Câmbio',
    buttons: {
      default: 'Comprar Câmbio',
      euro: 'Comprar Euro',
      dolar: 'Comprar Dólar',
      libra: 'Comprar Libra',
    },
    whatsAppMessage: {
      default:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Moedas Estrangeiras!',
      euro: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Euro!',
      dolar:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Dólar Americano!',
      libra:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre a Libra Esterlina!',
      moneygram:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre MoneyGram!',
      remessaInternacional:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre Remessas Internacionais!',
      consorcio:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Consórcio em Ouro!',
      seguroViagem:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre seguro viagem!',
    },
  },
  ouro: {
    title: 'Ouro',
    buttons: {
      default: 'Investir em Ouro',
      comprar: 'Comprar Ouro',
      comprarAgora: 'Comprar Agora',
      venderAgora: 'Vender Agora',
      investir: 'INVESTIR AGORA',
      mesa: 'MESA DE OPERAÇÕES'
    },
    whatsAppMessage: {
      default:
        'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Ouro!',
      b3: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Ouro B3!',
      joalheiro: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Ouro para joalheiros!',
      cartaoOuro: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre o Cartão OuroFácil!',
      piramide: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre a Pirâmide de Ouro!',
      vender: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre a venda de ouro!',
      exportacao: {pt: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre Exportação!',
        en: 'Hello, I just visited your website and I would like to speak with a human representative about Exportation!'
      },
      premiacaoBarra: 'Olá, acabei de visitar o site de vocês e gostaria de falar com um atendente humano sobre Premiação de Certificados em Barras de Ouro!'
    },
  },
  eccomerce: {
    entrega: {
      portador: {
        tittle: 'Portador',
        addresNotAllowed: ["Caieiras", "Itapevi", "Carapicuíba", "Itapecerica da Serra", "Taboão da Serra", "Franco da Rocha", "Francisco Morato", "Itaquaquecetuba", "Mogi das Cruzes", "Mauá", "Ribeirão Pires", "Suzano"]
      }
    }
  }
} as const;
